import React, { Fragment, useEffect, useState } from 'react';
import { keys, sortBy } from 'lodash';
import { arrayOf, object } from 'prop-types';
import 'react-dropdown-tree-select/dist/styles.css';
import DataExport from '../../../../ui-components/data-export/data-export.jsx';
import TableGrid from '../../../../ui-components/table-grid/table-grid.jsx';
import TabsContainer from '../../../../ui-components/tabs-container/tabs-container.jsx';
import { DateUtil } from '../../../../utils/date-util.js';
import { getCompetitionFareChangesConfig } from './grid-competition-fare-changes-config.js';
import { getFareChangesGridData } from './grid-competition-fare-changes-util.js';

const GridCompetitionFareChanges = ({
   fareChangesSummaryList,
   filterBy,
   pickedFareChange,
   showFaresBy,
}) => {
   const tabGenerator = (computedGridDataNew, filterBy) => {
      const competitionFareChangesConfig =
         getCompetitionFareChangesConfig(filterBy);
      const computedGridDataNewKeys = sortBy(
         keys(computedGridDataNew)
      ).reverse();
      return computedGridDataNewKeys.map((value, key, index) => ({
         tabTitle: DateUtil.formatDate(
            value,
            DateUtil.DATE_FORMATS.DAY_HYPHEN_MONTH_NAME
         ),
         tabContent: (
            <TableGrid
               key={DateUtil.getNowMoment()} //TODO: to implement in a better way
               gridKey={DateUtil.getNowMoment()} //TODO: to implement in a better way
               data={computedGridDataNew[value]}
               config={competitionFareChangesConfig}
            />
         ),
      }));
   };

   const [gridData, setGridData] = useState([]);
   const [tabContent, setTabContent] = useState([]);

   useEffect(() => {
      const computedGridDetails = getFareChangesGridData(
         fareChangesSummaryList,
         pickedFareChange,
         showFaresBy
      );
      const newTabContent = tabGenerator(
         computedGridDetails.transformedData,
         filterBy
      );
      setGridData(computedGridDetails.transformedData);
      setTabContent([...newTabContent]);
   }, [fareChangesSummaryList, showFaresBy, filterBy]);

   const tableConfig = getCompetitionFareChangesConfig(filterBy);
   const headers = [
      { key: 'date', label: 'Date' },
      ...tableConfig.configColumns,
   ];

   return (
      <Fragment>
         <div className='col-xs-12'>
            <div className='spark-pull-left'>
               <h5>COMPETITIVE CHANGES - FARE</h5>
            </div>
            <div className='spark-pull-right'>
               {gridData && (
                  <DataExport
                     data={gridData}
                     groupedKeys={['carrierCode', 'origin', 'destination']}
                     headers={headers}
                     isStackedData={true}
                     type='icon'
                     fileName={`Competition-Fare-Changes.csv`}
                  />
               )}
            </div>
         </div>

         <div className='col-xs-12 fo-spark-mar-t-4'>
            {tabContent && (
               <TabsContainer
                  config={{
                     tabsContainerCss:
                        'competitive-changes-fare-tabs-container-tabs-list',
                     tabs: tabContent,
                     tabOnClick: (e) => {},
                  }}
               />
            )}
         </div>
      </Fragment>
   );
};

GridCompetitionFareChanges.propTypes = {
   competitionFareChangesSummaryData: arrayOf(object),
};

export default GridCompetitionFareChanges;
